export const formatSoftDescriptor = (companyName: string): string => {
  const prefix = 'BPG*';
  const maxLength = 25;
  const maxNameLength = maxLength - prefix.length;

  // Remove all non-alphanumeric characters (including spaces)
  const cleanedName = companyName.replace(/[^a-zA-Z0-9]/g, '');

  const trimmedName = cleanedName.slice(0, maxNameLength);

  return prefix + trimmedName;
};
